import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
export const CreateTaskFromMessageLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-createtaskfrommessagecontainer" */ "./CreateTaskFromMessageContainer")).then((bundle)=>{
        return {
            default: bundle.CreateTaskFromMessageContainer
        };
    });
export const LazyCreateTaskFromMessageContainer = /*#__PURE__*/ lazy(CreateTaskFromMessageLazyLoader);
